var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#f08b1f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7192_33824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.349 10H27.8581C27.4985 10 27.2071 10.2914 27.2071 10.651C27.2071 11.0106 27.4985 11.3021 27.8581 11.3021H32.7872L20.1237 24.0869C19.8808 24.344 19.8875 24.7476 20.1385 24.9966C20.3895 25.2456 20.7933 25.2484 21.0481 25.0035L33.6979 12.2331V17.1419C33.6979 17.5015 33.9894 17.7929 34.349 17.7929C34.7086 17.7929 35 17.5015 35 17.1419V10.651C35 10.2914 34.7086 10 34.349 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1026 23.9641C30.7431 23.9641 30.4516 24.2556 30.4516 24.6152V31.7446C30.4503 32.8229 29.5768 33.6964 28.4985 33.6977H13.2552C12.1769 33.6964 11.3034 32.8229 11.3021 31.7446V16.5013C11.3034 15.423 12.1769 14.5494 13.2552 14.5482H20.3846C20.7442 14.5482 21.0357 14.2567 21.0357 13.8971C21.0357 13.5375 20.7442 13.2461 20.3846 13.2461H13.2552C11.4582 13.2481 10.002 14.7043 10 16.5013V31.7446C10.002 33.5416 11.4582 34.9978 13.2552 34.9998H28.4985C30.2955 34.9978 31.7517 33.5416 31.7537 31.7446V24.6152C31.7537 24.2556 31.4622 23.9641 31.1026 23.9641Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7192_33824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOrange);
export default __webpack_public_path__ + "static/media/share-orange.53623ed98d716eb41ae5c7e3caa1542e.svg";
export { ForwardRef as ReactComponent };